import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { filter, switchMap } from 'rxjs/operators';
import { RestService } from '../../../../services/rest-service.service';
import { ScDialogService } from '../../../sc-dialogs/sc-dialog.service';
import { ScGenericFormComponent } from '../../sc-generic-form.component';

@Component({
  selector: 'sc-field-link',
  templateUrl: './field-link.component.html',
  styleUrls: ['./field-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldLinkComponent extends FieldType implements OnInit {
  constructor(private _dialogService: ScDialogService, private _restService: RestService) {
    super();
  }

  onClick($event) {
    if (this.to.onClick) {
      this.to.onClick($event, this.field, this);
    }
  }

  ngOnInit(): void {}

  openDialog(formFields: FormlyFieldConfig[], title: string, initialData = {}, beforeRequest: (data: any) => any) {
    return this._dialogService
      .generic({
        componentRef: ScGenericFormComponent,
        title,
        data: initialData,
        isForFormly: true,
        formFields
      })
      .pipe(
        filter(data => !!data),
        switchMap(data => {
          const { endpoint, body } = beforeRequest(data);
          return this._restService.post(endpoint, body);
        })
      );
  }
}
